import Select from '../Atom/Select';
import React, { useState, useEffect, useMemo } from 'react';
import './style.css';
import { useSelector, useDispatch } from 'react-redux';
import { setStore as dispatchStore, setUserStores } from 'app/features/userSlice';
import Input from 'components/Atom/Input';
import { Button } from 'components/Atom/Button';
import { Divider, notification } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import http from 'utils/http';
import { USER_ROLES } from 'utils/constant';
import { checkUserPermissions } from 'utils/services';
import UserService from 'api/users';
import { useLocation, useNavigate } from 'react-router-dom';
const SelectStore = ({ onChange, setDefault = false, isLocalUse = false, disabled = false }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const userStoresData = useSelector((state) => state.company.userStores);
  const [userAllStores, setAllUserStores] = useState(null);
  const [storeName, setStoreName] = useState(null);
  const [isStoreOnboarding, setIsStoreOnboarding] = useState(false);
  const [newStoreOnboarding, setNewStoreOnboarding] = useState(false);
  const dispatch = useDispatch();
  const store = useSelector((state) => state.company.store);
  const onStoreSelect = (data) => {
    let selectedStoreData;
    if (data?.value === 'all_stores') {
      selectedStoreData = { ...userAllStores[0], isSelected: false };
      dispatch(dispatchStore(selectedStoreData));
      localStorage?.removeItem('store_id');
    } else {
      selectedStoreData = userAllStores?.find((store) => store?._id === data?.value);
      selectedStoreData = { ...selectedStoreData, isSelected: true };
      if (!isLocalUse) {
        dispatch(dispatchStore(selectedStoreData));
        localStorage.setItem('store_id', selectedStoreData?._id);
      }
    }
    onChange(selectedStoreData);
    navigate(location.pathname, { replace: true });
  };
  const onStoreNameChange = (e) => {
    setStoreName(e?.target?.value || null);
  };
  const onDropdownVisibleChange = (e) => {
    if (e) setIsStoreOnboarding(false);
  };
  useEffect(() => {
    setAllUserStores(userStoresData);
  }, [userStoresData]);
  const onboardNewStore = async () => {
    setNewStoreOnboarding(true);
    try {
      await http.post('/stores', { name: storeName });
      notification.success({ message: 'NEW STORE ONBOARD SUCCESSFULLY', placement: 'bottomRight' });
      const response = await UserService.me();
      setIsStoreOnboarding(false);
      dispatch(setUserStores(response?.data?.data?.store));
      setStoreName(null);
    } catch (err) {
      notification.error({ message: err?.response?.data?.message || 'Please try again', placement: 'bottomRight' });
    }
    setNewStoreOnboarding(false);
  };
  // set 0 index store selected if route is setting
  const isExcludeAllStoreOption = useMemo(() => {
    const routes = ['/setting', '/block-list', '/rules', '/payment-routing', '/users'];
    return routes.some((route) => location.pathname.includes(route));
  }, [location.pathname]);
  useEffect(() => {
    if (isExcludeAllStoreOption && !store?.isSelected) {
      dispatch(dispatchStore({ ...store, isSelected: true }));
    }
  }, [location.pathname]);
  return (
    <div>
      {userAllStores?.length > 0 && (
        <div className={isLocalUse ? '' : 'selectStore'}>
          <Select
            handleChange={onStoreSelect}
            showSearch
            onDropdownVisibleChange={onDropdownVisibleChange}
            disabled={disabled}
            value={setDefault || userAllStores?.length === 1 || store?.isSelected || isExcludeAllStoreOption ? store?._id : 'all_stores'}
            getPopupContainer={(triggerNode) => triggerNode.parentElement}
            filterOption={(input, option) => (option?.value ?? '').toLowerCase().includes(input.toLowerCase()) || (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
            optionsValue={
              userAllStores && userAllStores?.length > 1
                ? [
                    ...(setDefault || isExcludeAllStoreOption ? [] : [{ label: 'All Stores', value: 'all_stores' }]),
                    ...userAllStores.map((data) => ({ label: data?.name || data?.domain, value: data._id })),
                  ]
                : [{ label: userAllStores[0]?.name || userAllStores[0]?.domain, value: userAllStores[0]._id }]
            }
          />
        </div>
      )}
    </div>
  );
};
export default SelectStore;
